import {writable} from '@convincely/components/src/library.js';

export const customs = writable();
